import {
    FALLBACK_PLAYER_LABEL,
    PLAYER_ADDED_TITLE,
    VIEW_LIST_LABEL,
} from '../savedListsCopy';

// Dynamic success-toast copy for the Add-Player wizard, driven by playerCount × listCount
// (copy per Figma 453-15450). Kept as a pure builder so the variant matrix is unit-testable in
// isolation from the modal.

const MULTI_PLAYER_TITLE_SUFFIX = 'Players Successfully Added';

export { VIEW_LIST_LABEL };

export const buildAddPlayersToast = ({ playerCount, playerName, listCount, onViewList }) => {
    const title = playerCount === 1
        ? PLAYER_ADDED_TITLE
        : `${playerCount} ${MULTI_PLAYER_TITLE_SUFFIX}`;
    const name = playerName || FALLBACK_PLAYER_LABEL;

    let message;
    if (listCount > 1) {
        message = playerCount === 1
            ? `${name} has been added to ${listCount} lists.`
            : `${playerCount} players have been added to ${listCount} lists.`;
    } else {
        message = playerCount === 1
            ? `${name} has been added to your list.`
            : `${playerCount} players have been added to your list.`;
    }

    const toastData = { title, message };
    // "View List" only makes sense when there is a single target list to view — the N×M variant in
    // the design has no action link. The caller supplies onViewList (jump to that list from the hub,
    // or just dismiss when already viewing it in the single-step List Detail flow).
    if (listCount === 1 && onViewList) {
        toastData.actionLabel = VIEW_LIST_LABEL;
        toastData.onAction = onViewList;
    }
    return toastData;
};
